import React, { useState, useEffect } from 'react';
import './EventDetails.css';
import { useNavigate } from 'react-router-dom';
import EventData from "../Events/EventData";
import { useParams } from 'react-router-dom';
import HeaderAnimation from '../Header/HeaderAnimation';
import Title from "../Title/Title"

const EventDetails = () => {
  const [activeRound, setActiveRound] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isFlare, setIsFlare] = useState(false); // New state for flare
  const navigate = useNavigate();
  const { id } = useParams();
  const eventId = parseInt(id, 10);
  const event = EventData.find(event => event.id === eventId);

  const handleBackClick = () => {
    navigate('/');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleRoundClick = (index) => {
    if (index === activeRound) return; // Prevent re-triggering on the same round

    setIsAnimating(true);
    setIsFlare(true); // Trigger flare

    setTimeout(() => {
      setActiveRound(index);
      setIsAnimating(false);
    }, 300); // Match this duration with the CSS transition time

    // Remove flare after animation duration
    setTimeout(() => {
      setIsFlare(false);
    }, 600); // Duration of the flareFlash animation
  };

  return (
    <>
      <HeaderAnimation />
      <div className="container">
        <div className="row">
              <h2 className="desc-title ">{event.title}</h2>
        </div>

        <div className="row d-flex flex-wrap">
            <div className="tray same-size-tray desc-tray justify">
              <p>{event.description}</p>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 offset-md-2">
            <div className="tray-yellow">
              <span className="text-green">Eligibility«</span>
              <br />
              <br />
              <span className="text-yellow">CSE & CS</span>
              <br />
              <span className="text-yellow">{event.eligibility}</span>
            </div>
          </div>
        </div>

        {
          (event.rounds !== 0) ? <div className="col-12 col-md-8 mx-auto">
            <div className="tray trigger">
              <span className="text-green">RULES«</span>
              <br /><br />
              <div className="buttons-container d-flex flex-column align-items-center">
                {Array.from({ length: event.rounds }, (_, i) => (
                  <button
                    key={i}
                    className={`round-button ${activeRound === i ? 'active' : ''}`}
                    onClick={() => handleRoundClick(i)}
                  >
                    {`Round ${i + 1}`}
                  </button>
                ))}
              </div>
            </div>

            <div className={`justify tray trigger mt-3 round-desc ${isAnimating ? 'fade-out' : 'fade-in'} ${isFlare ? 'flare' : ''}`}>
              <p className="about-title">About Round {activeRound+1}:</p>
              <p>{event.round_descriptions[activeRound].round_description}</p>
            </div>
          </div> : <div></div>
        }

        <a href={event.url} target="_blank"><button className='register-btn' style={{ margin: '30px 0' }}>Register</button></a>
      </div>
    </>
  );
};

export default EventDetails;
